import { useMemo } from 'react';
import { useBootstrapSelector } from '../../../redux/selectorHooks';
import { assertNotNil } from '../../../utils/types';

export const useInspectReportSettingFieldKeys = (
  schemaId: string,
): string[] => {
  const currentReportSetting = useBootstrapSelector('reportSetting');
  assertNotNil(currentReportSetting);
  const { inspect } = currentReportSetting;
  const { schemaInspectSettings } = inspect;

  return useMemo(() => {
    if (!schemaInspectSettings?.length) {
      return [];
    }

    // If exists, find a schema specific inspect setting field keys.
    // This list will be used for initial Inspect Subject mutation only.
    return (
      schemaInspectSettings.find(
        (schemaInspectSetting) => schemaInspectSetting.schema.id === schemaId,
      )?.fields ?? []
    ).map((field) => field.key);
  }, [schemaId, schemaInspectSettings]);
};
